import PropTypes from 'prop-types'

import Moment from 'react-moment'
import Table from 'components/table/Table'
import NoneAnchor from 'components/NoneAnchor'
import Icon from 'components/Icon'
import { Fragment } from 'react'

const DocumentListItem = ({
  document: {
    channelName,
    siteUrl: { mobileUrl, pcUrl },
    creativeDocuments,
    channelDocuments,
  },
  onClick,
  onDeleteClick,
  id,
}) => {
  const getFileNames = ({ files }) =>
    files.map(({ id: fileId, filename, url }) => (
      <div key={`${fileId}_name`} className="box_file">
        <button
          type="button"
          className="btn_del"
          onClick={() => onDeleteClick({ id: fileId, filename })}>
          <Icon name="del">삭제</Icon>
        </button>
        <a href={`${url}&download`} className="link_filedown">
          {filename}
        </a>
      </div>
    ))
  const getFileIds = ({ files }) =>
    files.map(({ id: fileId }, index, array) => (
      <Fragment key={fileId}>
        {fileId}
        {index < array.length - 1 && <br />}
      </Fragment>
    ))
  return (
    <>
      <Table.Row hoverClassName="over" rowId={id}>
        <td rowSpan="2">
          <div className="inner_tbl" onClick={onClick}>
            <NoneAnchor className="link_txt" onClick={onClick}>
              {channelName}
            </NoneAnchor>
            {mobileUrl && (
              <NoneAnchor className="link_txt" style={{ color: '#333' }}>
                {mobileUrl}
              </NoneAnchor>
            )}
            {pcUrl && (
              <NoneAnchor className="link_txt" style={{ color: '#333' }}>
                {pcUrl}
              </NoneAnchor>
            )}
          </div>
        </td>
        <td>
          <div className="inner_tbl">소재 심사서류</div>
        </td>
        <td>
          <div className="inner_tbl">{getFileIds(creativeDocuments)}</div>
        </td>
        <td>
          <div className="inner_tbl">{getFileNames(creativeDocuments)}</div>
        </td>
        <td>
          <div className="inner_tbl">
            {creativeDocuments.lastUpdateDate ? (
              <Moment format="YYYY.MM.DD HH:mm">
                {creativeDocuments.lastUpdateDate}
              </Moment>
            ) : (
              '-'
            )}
          </div>
        </td>
      </Table.Row>
      <Table.Row hoverClassName="over" rowId={id}>
        <td className="line_left">
          <div className="inner_tbl" style={{ paddingLeft: '12px' }}>
            비즈채널 심사서류
          </div>
        </td>
        <td>
          <div className="inner_tbl">{getFileIds(channelDocuments)}</div>
        </td>
        <td>
          <div className="inner_tbl">{getFileNames(channelDocuments)}</div>
        </td>
        <td>
          <div className="inner_tbl">
            {channelDocuments.lastUpdateDate ? (
              <Moment format="YYYY.MM.DD HH:mm">
                {channelDocuments.lastUpdateDate}
              </Moment>
            ) : (
              '-'
            )}
          </div>
        </td>
      </Table.Row>
    </>
  )
}

export default DocumentListItem

DocumentListItem.propTypes = {
  document: PropTypes.shape({
    channelName: PropTypes.string.isRequired,
    siteUrl: PropTypes.shape({
      mobileUrl: PropTypes.string,
      pcUrl: PropTypes.string,
    }).isRequired,
    creativeDocuments: PropTypes.shape({
      files: PropTypes.array.isRequired,
      lastUpdateDate: PropTypes.string,
    }).isRequired,
    channelDocuments: PropTypes.shape({
      files: PropTypes.array.isRequired,
      lastUpdateDate: PropTypes.string,
    }).isRequired,
  }),
  onClick: PropTypes.func.isRequired,
  onDeleteClick: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
}
